<template>
  <div class="kt-portlet kt-portlet--mobile">
    <!--begin::Form-->
    <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
      <div class="kt-portlet__head kt-portlet__head--lg">
        <div class="kt-portlet__head-label">
          <span class="kt-portlet__head-icon">
            <i class="kt-font-brand flaticon-home"></i>
          </span>
          <h3 class="kt-portlet__head-title">
            {{ this.$route.meta.breadcrumb }}
          </h3>
        </div>
      </div>
      <div class="kt-portlet__body">
        <div class="kt-section kt-section--first">
          <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="label-required">ชื่อเขตการขาย:</label>
                <input
                  id="sauName"
                  name="sauName"
                  v-model="sauName"
                  type="text"
                  maxlength="256"
                  class="form-control"
                  placeholder="ชื่อเขตการขาย"
                />
                <span class="form-control-plaintext"></span>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="label">จังหวัด:</label>
                <select2
                  :class="'form-control m-select2'"
                  :style="'width: 100%;'"
                  :id="'sauProvince'"
                  :name="'sauProvince'"
                  :multiple="true"
                  :select2-options="sauProvinceOptions"
                  v-model="sauProvince"
                  ref="sauProvinceSelect2"
                ></select2>
                <span class="form-text"></span>
              </div>
            </div>
          </div>

          <!-- Begin:InActiveStatus element -->
          <div class="row">
            <div class="col-xl-12">
              <div class="form-group">
                <label>สถานะ:</label>
                <div class="form-check">
                  <label class="form-check-label kt-checkbox">
                    <input
                      id="sauInActiveStatus"
                      name="sauInActiveStatus"
                      v-model="sauInActiveStatus"
                      type="checkbox"
                      class="form-check-input"
                    />
                    เปิดใช้งาน
                    <span></span>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <!-- End:InActiveStatus element -->
        </div>
      </div>
      <div class="kt-portlet__foot">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="$router.go(-1)"
        >
          <i class="la la-close"></i> ย้อนกลับ
        </button>
        <button type="submit" class="btn btn-primary">
          <i class="la la-save"></i> บันทึกข้อมูล
        </button>
      </div>
    </form>
    <!--end::Form-->
  </div>
</template>

<script>
import axios from "axios";
import select2 from "../../../Shared/Select2";
import plupload from "plupload";
import Vue from "vue";
import * as VueGoogleMaps from "vue2-google-maps";

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyCeGao-PkONmiyVksl46W_OUHt854bcrqE",
    libraries: "places",

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },
});

export default {
  components: {
    select2,
  },
  name: "GoogleMap",
  data: function() {
    var self = this;
    return {
      sauProvince: [],
      sauName: null,
      sauInActiveStatus: null,
      sauProvinceOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/MasterLocation/Select2SearchProvince",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
    };
  },
  methods: {
    formSubmit: function(e) {
      if (
        !$(this.$refs.form)
          .validate()
          .form()
      ) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่...",
      });

      let router = this.$router;
      let self = this;
      axios
        .put("/Api/MasterSalesArea", {
          Id: this.$route.params.SalesAreaid,
          Name: this.sauName,
          ProvinceId: this.sauProvince,
          InActiveStatus: !this.sauInActiveStatus,
        })
        .then(function(response) {
          if (response.data.status) {
            KTApp.unblockPage();
            Swal.fire("สำเร็จ", response.data.message, "success").then(
              function() {
                router.go(-1), self.$parent.reloadDataTable(false);
              }
            );
          } else {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          // always executed
          KTApp.unblockPage();
        });
    },
  },
  async mounted() {
    let self = this;
    let router = this.$router;
    let user = await this.$root.getUser();
    //self.initPlUploader();

    KTApp.blockPage({
      opacity: 0.05,
      message: "กำลังดึงข้อมูล กรุณารอสักครู่...",
    });

    axios
      .get("/Api/MasterSalesArea/" + this.$route.params.SalesAreaid)
      .then(function(response) {
        if (response.status == 200) {
          self.sauName = response.data.name;
          self.sauInActiveStatus = !response.data.inActiveStatus;
          if (response.data.salesAreaProvince) {
            var provinceOptions = $.map(
              response.data.salesAreaProvince,
              function(obj, idx) {
                return {
                  id: obj.provinceId,
                  text: obj.provinceName,
                };
              }
            );
            self.$refs.sauProvinceSelect2.setSelectedData(provinceOptions);
          }
        } else {
          Swal.fire(
            "เกิดข้อผิดพลาด",
            "ไม่พบข้อมูลเขตการขายคุณเลือก",
            "warning"
          );
          router.go(-1);
        }
      })
      .catch(function(error) {
        Swal.fire(
          "เกิดข้อผิดพลาด",
          "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลเขตการขายได้ในขณะนี้",
          "error"
        );
        router.go(-1);
      })
      .then(function() {
        // always executed
        KTApp.unblockPage();
      });

    //set validation rules
    $(this.$refs.form).validate({
      rules: {
        sacName: "required",
      },
      messages: {
        sacName: "กรุณากรอกชื่อเขตการขาย",
      },
    });
  },
};
</script>
<style lang="scss">
#myProgress {
  width: 100%;
  background-color: #ddd;
}

.myBar {
  width: 10%;
  height: 30px;
  background-color: #4caf50;
  text-align: center;
  line-height: 30px;
  color: white;
}

.btm-reload-img-plant {
  position: absolute;
  top: 5px;
  right: 20px;
}
.btm-delete-img-plant {
  position: absolute;
  top: 5px;
  right: 70px;
}
.btm-remove-img-plant {
  position: absolute;
  top: 5px;
  right: 20px;
}

.select2,
.select2-dropdown {
  font-size: 1.2rem;
}

@media (max-width: 425px) {
  .m-body .m-content {
    padding: 20px 5px;
  }
}

@media (max-width: 1200px) {
  .m-wizard.m-wizard--2 {
    margin-top: 8rem !important;
  }

  #activity_wizard .m-wizard__form .m-form .m-portlet__body {
    padding: 2.2rem 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// App/Components/Master/SalesArea/SalesAreaUpdate.vue